import { render } from "./CharactersCounter.vue?vue&type=template&id=28a8ab7c"
import script from "./CharactersCounter.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./CharactersCounter.vue?vue&type=script&charset=utf-8&lang=js"

import "./CharactersCounter.vue?vue&type=style&index=0&id=28a8ab7c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__